var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 12,
    cy: 12,
    r: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.795 13.52c.435 0 .75-.345.81-.735l.045-.27c1.635-.33 2.955-1.11 2.955-3.015v-.03c0-1.995-1.47-3.105-3.63-3.105-1.32 0-2.325.42-3.12 1.08-.27.225-.39.525-.39.81 0 .57.48 1.05 1.05 1.05.255 0 .495-.105.675-.24.54-.405 1.095-.6 1.74-.6.87 0 1.38.39 1.38 1.065v.03c0 .735-.6 1.14-1.905 1.305-.48.06-.765.405-.69.9l.15 1.02c.06.405.375.735.81.735h.12Zm-1.425 2.265v.03c0 .72.555 1.275 1.305 1.275.75 0 1.305-.555 1.305-1.275v-.03c0-.72-.555-1.275-1.305-1.275-.75 0-1.305.555-1.305 1.275Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.8ab16d98a5a12b7492637ef6bf84b85c.svg";
export { ForwardRef as ReactComponent };